import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Sostenedor } from '../models/sostenedor.model';

@Injectable({
  providedIn: 'root'
})
export class SostenedorService {
  url = GlobalVariable.BASE_API_URL;
  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: this.token.replace(/["']/g, '')
  });
  constructor(private http: HttpClient) { }
  public UpdateSostenedor(sostenedor: Sostenedor) {
    return this.http.post(`${this.url}Contact/setSostenedor`, JSON.stringify(sostenedor), { headers: this.headersc });
  }
}
